import Article from 'src/adminPanel/entities/articleManagement/Article';
import ArticleGroup from 'src/adminPanel/entities/articleManagement/ArticleGroup';
import CommissionModel from 'src/adminPanel/entities/articleManagement/CommissionModel';
import VideoCategoryAdmin from 'src/adminPanel/entities/it/videos/VideoCategoryAdmin';
import ProductGroup from 'src/entities/product-group/ProductGroup';
import Product from 'src/entities/products/Product';
import Representative from 'src/entities/representatives/Representative';
import VolumeDiscount from 'src/entities/volume-discount/VolumeDiscount';
import { Projection } from 'src/store/entities/types/EntityDescription';
import { EntityDescriptions } from 'src/store/entities/types/index';

export function bootstrapProjections() {
    EntityDescriptions.REPRESENTATIVE.projectionsTypeMap[Projection.NONE] = Representative;
    EntityDescriptions.PRODUCT_GROUP.projectionsTypeMap[Projection.NONE] = ProductGroup;
    EntityDescriptions.PRODUCTS.projectionsTypeMap[Projection.NONE] = Product; // AdminPanel
    EntityDescriptions.PRODUCTS.projectionsTypeMap[Projection.RECOMMENDED] = Product; // AdminPanel
    EntityDescriptions.PRODUCT.projectionsTypeMap[Projection.NONE] = Product;
    EntityDescriptions.PRODUCT.projectionsTypeMap[Projection.RECOMMENDED] = Product;
    EntityDescriptions.PRODUCT.projectionsTypeMap[Projection.FULL] = Product;
    EntityDescriptions.VOLUME_DISCOUNT.projectionsTypeMap[Projection.NONE] = VolumeDiscount;
    EntityDescriptions.ARTICLE_GROUPS_LIST.projectionsTypeMap[Projection.NONE] = ArticleGroup; // AdminPanel
    EntityDescriptions.ARTICLE_ARTICLES_LIST.projectionsTypeMap[Projection.NONE] = Article; // AdminPanel
    EntityDescriptions.ARTICLE_COMMISSION_MODELS.projectionsTypeMap[Projection.NONE] = CommissionModel; // AdminPanel
    EntityDescriptions.VIDEO_CATEGORIES.projectionsTypeMap[Projection.NONE] = VideoCategoryAdmin; // AdminPanel
    checkProjections();
}

function checkProjections() {
    Object.keys(EntityDescriptions).forEach(key => {
        const entityDescription = EntityDescriptions[key as keyof typeof EntityDescriptions];
        Object.keys(entityDescription.projectionsTypeMap).forEach(projection => {
            const entityConstructor = entityDescription.projectionsTypeMap[projection];
            if (entityConstructor == null)
                throw new Error(
                    `No projection "${projection}" defined in EntityDescription "${entityDescription.name}"`
                );
        });
    });
}
